import * as React from "react"
import styled from "styled-components"
import { Line } from "../../interfaces/SaleorTypes"
import "react-datepicker/dist/react-datepicker.css"
import { getFormattedPrice } from "../../../utils/cart-helpers"
import H4 from "../../atoms/typography/H4"
import BodyMedium from "../../atoms/typography/BodyMedium"

interface ConfirmationDataPlanSectionProps {
  lines: Line[]
  status: string
}

const SubHeaderWrapper = styled.div`
  margin-bottom: 0.4em;
`

const Divider = styled.div`
  border: solid 1px #898989;
`

const CheckoutDataPlanContainer = styled.div`
  padding: 1em 0 0 0;
`

const ImageWrapper = styled.div`
  justify-content: center;
  display: flex;
`

const MainHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1.5em;
  white-space: nowrap;
  padding: 0.75em 0;
`

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1.5em;
  white-space: nowrap;
  padding: 0.75em 0;
  justify-content: space-between;
`

const ConfirmationDataPlanSection: React.FunctionComponent<ConfirmationDataPlanSectionProps> = ({
  lines,
  status,
  ...props
}) => {
  const renderDataPlan = () => {
    return (
      lines.length > 0 &&
      lines.map(
        (item: Line, index: any) =>
          item.variant.product?.category.name == "Data plans" && (
            <CheckoutDataPlanContainer key={index}>
              <MainHeaderContainer>
                <H4>{item.variant.product.name}</H4>
                <ImageWrapper>
                  <img src={item.variant.product.media[0]?.url} width={150} />
                </ImageWrapper>
              </MainHeaderContainer>
              <HeaderContainer>
                <H4>Duration: </H4>
                <BodyMedium>1 year</BodyMedium>
              </HeaderContainer>
              <HeaderContainer>
                <H4>Data amount: </H4>
                <BodyMedium>{item.variant.name}</BodyMedium>
              </HeaderContainer>
              <HeaderContainer>
                <BodyMedium>Price: </BodyMedium>
                <BodyMedium>
                  {status == "UNCONFIRMED"
                    ? "TBD"
                    : getFormattedPrice(item.totalPrice.gross.amount, item.totalPrice.gross.currency)}
                </BodyMedium>
              </HeaderContainer>
            </CheckoutDataPlanContainer>
          ),
      )
    )
  }

  const checkIfCategoryExists = () => {
    let flag = false
    lines.map((item: Line) => {
      if (item.variant.product?.category.name == "Data plans") {
        flag = true
      }
    })
    return flag
  }

  return (
    <div>
      {lines && lines.length > 0 && checkIfCategoryExists() && (
        <div>
          <SubHeaderWrapper>
            <BodyMedium>Data plan</BodyMedium>
          </SubHeaderWrapper>
          <Divider />
          {renderDataPlan()}
        </div>
      )}
    </div>
  )
}

export default ConfirmationDataPlanSection
